import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectedDangerModeSelector, setSelectedDangerMode } from '../filtersSlice';
import { SelectedBooleanStatusType } from '../utils';

export const useSelectedDangerMode = () => {
  const dispatch = useDispatch();
  const dangerMode = useSelector(selectedDangerModeSelector);

  const onSelectDangerMode = React.useCallback((selected: SelectedBooleanStatusType) => {
    dispatch(setSelectedDangerMode(selected));
  }, [dispatch]);

  return {
    dangerMode,
    onSelectDangerMode,
  };
};
